import { ReactNode, useId, useState } from 'react';
import './CollapsibleNote.css';

interface CollapsibleNoteProps {
  /** Short label, always visible: says what the note is about without taking the space of the note itself. */
  title: ReactNode;
  variant?: 'info' | 'warn';
  defaultOpen?: boolean;
  children: ReactNode;
}

/**
 * Warnings and explanatory notes of the analytics tabs. Closed by default: fixed, they sit between the reader and
 * the numbers. The body stays mounted (hidden) so an open/closed toggle never resets what is inside it.
 */
export const CollapsibleNote: React.FC<CollapsibleNoteProps> = ({ title, variant = 'info', defaultOpen = false, children }) => {
  const [open, setOpen] = useState(defaultOpen);
  const bodyId = useId();

  return (
    <div className={`analytics-note analytics-note-${variant}${open ? ' open' : ''}`}>
      <button
        type="button"
        className="analytics-note-toggle"
        aria-expanded={open}
        aria-controls={bodyId}
        onClick={() => setOpen((current) => !current)}
      >
        <span className="analytics-note-title">{title}</span>
        <span className="analytics-note-chevron" aria-hidden="true" />
      </button>
      <div id={bodyId} className="analytics-note-body" hidden={!open}>
        {children}
      </div>
    </div>
  );
};

export default CollapsibleNote;
